import { render } from "./SubiektSettings.vue?vue&type=template&id=042061c3&scoped=true"
import script from "./SubiektSettings.vue?vue&type=script&lang=js"
export * from "./SubiektSettings.vue?vue&type=script&lang=js"

import "./SubiektSettings.vue?vue&type=style&index=0&id=042061c3&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042061c3"]])

export default __exports__